module.exports = __webpack_public_path__ + "img/轮播7.e72468a8.png";